<template>
  <div class="space-y-4">
    <div
      v-for="(item, index) in localSection.data.items"
      :key="index"
      class="border border-gray-200 rounded-lg p-4"
    >
      <div class="flex justify-between items-center mb-3">
        <h4 class="font-semibold">Project {{ index + 1 }}</h4>
        <button
          v-if="localSection.data.items.length > 1"
          @click="removeItem(index)"
          class="text-red-600 hover:text-red-800"
        >
          Remove
        </button>
      </div>
      <div class="space-y-3">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Project Name</label>
          <input
            v-model="item.name"
            type="text"
            class="form-input w-full"
            placeholder="Project Name"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Description</label>
          <textarea
            v-model="item.description"
            class="form-input w-full"
            rows="3"
            placeholder="Project description..."
          ></textarea>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Technologies</label>
          <input
            v-model="item.technologies"
            type="text"
            class="form-input w-full"
            placeholder="React, Node.js, MongoDB"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">URL (Optional)</label>
          <input
            v-model="item.url"
            type="url"
            class="form-input w-full"
            placeholder="https://project-url.com"
          />
        </div>
      </div>
    </div>
    <button
      @click="addItem"
      class="w-full px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-gray-400 hover:text-gray-700 transition-colors"
    >
      + Add Project
    </button>
    <button
      @click="save"
      class="w-full px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
    >
      Save Section
    </button>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localSection: JSON.parse(JSON.stringify(this.section))
    }
  },
  methods: {
    addItem() {
      this.localSection.data.items.push({
        name: '',
        description: '',
        technologies: '',
        url: ''
      })
    },
    removeItem(index) {
      this.localSection.data.items.splice(index, 1)
    },
    save() {
      this.$emit('update', this.localSection)
    }
  }
}
</script>

